import React from 'react';
import ContactList from '../components/contact/ContactList';

const ContactPage = () => {
    return (
        <ContactList />
    );
}

export default ContactPage;
